import { BehaviorSubject } from 'rxjs';
import { GlobalRxStores } from '../reactiveX/globalRxStores.js';
import { router, buildRoutes, unauthenticatedRoutes } from '../router.js';
export class AuthGuard {
    constructor() {
        this.authenticated = false;
        this.store = GlobalRxStores.getDefaultStore();
    }
    // eslint-disable-next-line class-methods-use-this
    isAuthenticated() {
        const blueUser = this.store.behaviorSubjectsByKey.get('blueUser');
        const value = blueUser === null || blueUser === void 0 ? void 0 : blueUser.getValue();
        this.authenticated = value.status === 'AUTHENTICATED';
    }
    async fetchGrants() {
        var _a;
        if (process.env.NODE_ENV === 'production') {
            return null;
        }
        const blueUser = this.store.behaviorSubjectsByKey.get('blueUser');
        const blueToken = blueUser === null || blueUser === void 0 ? void 0 : blueUser.getValue();
        if (!(blueToken === null || blueToken === void 0 ? void 0 : blueToken.accessToken))
            return null;
        try {
            const response = await fetch(`${process.env.APP_SERVICES_2025}/blue/tokenbridge`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${blueToken.accessToken}`,
                    'Content-Type': 'application/json',
                },
            });
            const auth = await response.json();
            if (auth === null || auth === void 0 ? void 0 : auth.grants) {
                this.store.behaviorSubjectsByKey.set('authGrants', new BehaviorSubject(auth.grants));
            }
            return (_a = auth === null || auth === void 0 ? void 0 : auth.grants) !== null && _a !== void 0 ? _a : null;
        }
        catch (e) {
            return null;
        }
    }
    async appRoutes() {
        this.isAuthenticated();
        if (!this.authenticated) {
            router.setRoutes(unauthenticatedRoutes);
            return;
        }
        if (this.authenticated && router.getRoutes().length === 0) {
            const grants = await this.fetchGrants();
            router.setRoutes(buildRoutes(grants));
        }
    }
}
//# sourceMappingURL=authGuard.js.map